import { motion } from 'framer-motion';
import { Bot } from 'lucide-react';

import { useTrackEvent } from '@/lib/posthog/hooks/useTrackEvent';
import { cn } from '@/lib/utils';
import { useLayoutActions } from '@/modules/layouts/layoutStore';

export const CopilotFloatButton = () => {
  const { toggleCopilotVisibility } = useLayoutActions();

  const trackEvent = useTrackEvent();

  const toggleCopilot = () => {
    toggleCopilotVisibility();
    trackEvent('copilotOpened');
  };

  return (
    <motion.button
      onClick={toggleCopilot}
      className={cn(
        'fixed right-6 bottom-6 z-50',
        'flex items-center justify-center',
        'bg-primary text-primary-foreground rounded-full shadow-lg',
        'hover:bg-primary/90 active:scale-95',
        'transition-colors duration-200',
        'focus:ring-primary size-12 cursor-pointer focus:ring-2 focus:ring-offset-2 focus:outline-none',
      )}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
    >
      <Bot className="h-5 w-5" />
    </motion.button>
  );
};
